import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section className="py-24 md:py-32 px-6 bg-background" data-id="element-17">
      <div className="max-w-2xl mx-auto text-center" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-19">
          <span className="text-sage font-medium tracking-widest text-sm uppercase mb-4 block" data-id="element-20">
            Om oss
          </span>

          <h2 className="text-3xl md:text-4xl font-normal text-ink mb-8" data-id="element-21">
            Liten nog att bry sig. Stor nog att leverera.
          </h2>

          <div className="space-y-6 text-lg text-muted leading-relaxed" data-id="element-22">
            <p data-id="element-23">
              Humble Consulting är mitt bolag — och en del av nätverket{' '}
              <a href="https://www.be-brave.se" target="_blank" rel="noopener noreferrer" className="text-terracotta hover:text-terracotta/80 underline underline-offset-2 transition-colors" data-id="element-24">
                Be Brave
              </a>
              . Ibland jobbar jag ensam, ibland med nätverket. Det beror på vad
              uppdraget kräver — inte på vad som ser bra ut i en offert.
            </p>

            <p data-id="element-25">
              Vår spets är komplexa problem utan självklara svar. Sådant som
              kräver att någon faktiskt sätter sig in i verksamheten, inte bara
              skickar en modell och önskar lycka till.
            </p>

            <p data-id="element-26">
              Vi jobbar med ett fåtal kunder åt gången — på riktigt, utifrån
              dina utmaningar. Inte utifrån våra.
            </p>

            <p className="text-base italic opacity-80 mt-8" data-id="element-27">
              Vi har testat det andra sättet. Kunden fick en snygg rapport. Och
              exakt samma problem.
            </p>

            <img src="https://cdn.magicpatterns.com/uploads/5BD8gTNsE9RcP1tAZ5AeP8/image.png" alt="Teamet firar" className="max-w-[200px] mx-auto mt-8 opacity-80" data-id="element-28" />
          </div>
        </motion.div>
      </div>
    </section>;
}